import { COMMON_REDUX_STORE_CLEAR } from '~shared/components/react/CommonDataStore/actionTypes';

import { initialState } from './initialState';
import { META_DATA_REDUX_STORE_UPDATE } from './actionTypes';

/**
 * @param {*} state the current state
 * @param {*} action the action
 * @returns {*} new state
 */
export default function metaDataReducer(state = initialState, action) {
    switch (action.type) {
        case META_DATA_REDUX_STORE_UPDATE:
            return { ...state, ...action.data };
        case COMMON_REDUX_STORE_CLEAR:
                return initialState;
        default:
            return state;
    }
}
